import React from "react";
import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      kicker="LEGAL"
      title="Privacy Policy"
      updated="Last updated: May 30, 2026"
    >
      <p>
        Qontri ("we", "our", or "us") provides a platform for managing shared
        expenses, contributions, and settlements among groups.
      </p>

      <h2>Information We Collect</h2>
      <p>We may collect:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Account credentials</li>
        <li>Expense and group information entered by users</li>
        <li>Device and usage information necessary for app functionality</li>
      </ul>

      <h2>How We Use Information</h2>
      <p>We use information to:</p>
      <ul>
        <li>Provide and maintain the Qontri service</li>
        <li>Authenticate users</li>
        <li>Send account-related emails and OTP verification codes</li>
        <li>Improve application performance and security</li>
        <li>Respond to support requests</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>We do not sell personal information.</p>
      <p>
        Information may be shared with trusted service providers that help us
        operate the service, including authentication, hosting, analytics, and
        email delivery providers.
      </p>

      <h2>Data Security</h2>
      <p>
        We take reasonable measures to protect user information from
        unauthorized access, alteration, disclosure, or destruction.
      </p>

      <h2>User Rights</h2>
      <p>
        Users may request access, correction, or deletion of their personal
        information by contacting{" "}
        <a href="mailto:support@qontri.in">support@qontri.in</a>.
      </p>

      <h2>Account Deletion</h2>
      <p>
        Users may delete their account from within the application or by
        contacting <a href="mailto:support@qontri.in">support@qontri.in</a>.
      </p>

      <h2>Contact</h2>
      <p>
        For questions regarding this Privacy Policy, contact:{" "}
        <a href="mailto:support@qontri.in">support@qontri.in</a>
      </p>
    </LegalLayout>
  );
}
